module.exports = __webpack_public_path__ + "img/product-siwei-shuxue.73c80998.jpg";